import { render, staticRenderFns } from "./TalkRank.vue?vue&type=template&id=f4ea407e&scoped=true&"
import script from "./TalkRank.vue?vue&type=script&lang=ts&"
export * from "./TalkRank.vue?vue&type=script&lang=ts&"
import style0 from "./TalkRank.vue?vue&type=style&index=0&id=f4ea407e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ea407e",
  null
  
)

export default component.exports